import { Badge } from "@/components/ui/badge";
import type { LifecyclePhase, DesiredRunState } from "@/types";

// #redesign Welle A — zentrale Agent-Lifecycle→Badge-Mapper. War lokal in Agents/Detail.tsx;
// jetzt von Liste UND Detail genutzt (DRY). Variant-Mapping (docs/09, #201): running grün,
// starting blau, crashed/crashloop rot, degraded/unknown/suspended gelb, Rest grau.
type PhaseBadgeVariant = "online" | "offline" | "enrolled" | "busy" | "revoked";

export function phaseVariant(phase: string): PhaseBadgeVariant {
  if (phase === "running") return "online";
  if (phase === "starting") return "enrolled";
  if (phase === "crashed" || phase === "crashloopbackoff") return "revoked";
  if (phase === "degraded" || phase === "unknown" || phase === "suspended") return "busy";
  return "offline"; // stopped, unassigned, draining, migrating
}

const PHASE_LABEL: Record<string, string> = {
  unassigned: "Unassigned",
  stopped: "Stopped",
  starting: "Starting",
  running: "Running",
  degraded: "Degraded",
  draining: "Draining",
  crashed: "Crashed",
  crashloopbackoff: "CrashLoop",
  suspended: "Suspended",
  migrating: "Migrating",
  unknown: "Unknown",
};

export function phaseLabel(phase: string): string {
  return PHASE_LABEL[phase] ?? phase;
}

export function desiredVariant(d: string): "online" | "offline" | "busy" {
  if (d === "running") return "online";
  if (d === "suspended") return "busy";
  return "offline";
}

// Beobachteter FSM-Zustand (lifecyclePhase).
export function AgentPhaseBadge({ phase }: { phase: LifecyclePhase | string }) {
  return <Badge variant={phaseVariant(phase)}>{phaseLabel(phase)}</Badge>;
}

// Admin-Absicht (desiredRunState) — dezenter dargestellt (outline-artig über Variant).
export function DesiredStateBadge({ state }: { state: DesiredRunState | string }) {
  return <Badge variant={desiredVariant(state)}>{state}</Badge>;
}
